export interface SuportAreaTranslations {
	title: string;
	questionTitle: string;
	questionDescription: string;
	openTicket: string;
	close: string;
}

export const SUPORT_AREA_PT_BR: SuportAreaTranslations = {
	title: "Central de ajuda",
	questionTitle: "Precisa de ajuda?",
	questionDescription: "Abra um chamado e fale com nosso time de suporte.",
	openTicket: "Novo chamado",
	close: "Fechar",
};
